import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

interface TitularRutResponse {
  aptoNro: number;
  aptoNroSpecified: boolean;
  calle: string;
  calleNro: number;
  calleNroSpecified: boolean;
  ciudad: string;
  departamento: string;
  naturalezaFiscal: string;
  nombreFantasia: string;
  razonSocial: string;
  tipoEntidad: number;
  tipoEntidadSpecified: boolean;
  nombre: string;
  ruc: string;
}

type QueryType = {
  rut: string | null;
};
interface ApiResponse<T> {
  value: T;
}

export const titularRut = async (
  query: QueryType
): Promise<TitularRutResponse> => {
  try {
    const res = await apiClient.post<ApiResponse<TitularRutResponse>>(
      Endpoints.TitularRut,
      query
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      if (error.response.status === 404) {
        throw new Error('No se encontró el titular con el RUT ingresado.');
      } else {
        throw new Error(error.message);
      }
    } else {
      throw error;
    }
  }
};
